import { render, staticRenderFns } from "./GenericDashboard.vue?vue&type=template&id=2537f740&scoped=true&"
import script from "./GenericDashboard.vue?vue&type=script&lang=js&"
export * from "./GenericDashboard.vue?vue&type=script&lang=js&"
import style0 from "./GenericDashboard.vue?vue&type=style&index=0&id=2537f740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2537f740",
  null
  
)

export default component.exports